define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var _ = require('underscore');

    return Marionette.ItemView.extend({
        template: '<span class="badge badge-important">{{#if number}} {{ number }} {{/if}}</span>',

        className: 'fa fa-envelope js-btn-msgs',

        initialize: function () {
            this.model = new Backbone.Model();
            this.listenTo(app.Models.Counters, 'change:unseen_chats', this.setCount);
            this.setCount();
        },

        setCount: function() {
            this.model.set('number', +(app.Models.Counters.get('unseen_chats') || 0));
            this.render();
        },

        onDestroy: function() {
            app.Models.Counters.off('change:unseen_chats', this.setCount, this);
        }

    });
});